import Icon from 'veui/components/Icon'
import { IconChevronDoubleDown } from 'dls-icons-vue'

Icon.register('chevron-double-down', IconChevronDoubleDown)
